import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Form from "../common/Form";
import TextInput from "../common/TextInput";
import TextAreaInput from "../common/TextAreaInput";
import Row from "../common/Row";
import DateInput from "../common/DateInput";
import AutoComplete from "../common/AutoComplete";
import Files from "../common/Files";
import { FileComponentNames, COLOR_BLUE } from "../../constants/ComponentConstants";
import { getPropertyFilesComponentProps } from "../../components/common/FilesHelperUtil";
import AdresWizard from "../adresWizard/adresWizard";
import FriendlyCaptcha from "../common/FriendlyCaptcha";

const ExterneKlachtenForm = (props) => {
    const {
        klachtenModel,
		onAdresSave,
        onChange,
        onSave,
        onDropFiles,
        onRemoveFile,
		onCaptchaVerified,
        fileDownloadUrl,
        filesComponent,
		sendButtonDisabled,
        errors
    } = props;

    const filesMimeTypes = 'application/vnd.ms-excel,application/msexcel, application/x-excel, application/x-msexcel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, image/png, image/jpeg, image/jpeg, image/gif, image/tiff';
    const filesExtensions = 'pdf, xls, xlsx, doc, docx, ppt, pptx, jpeg, jpg, gif, png, tiff';
    const filesProps = getPropertyFilesComponentProps("Bijlagen", FileComponentNames.KLACHTEN, fileDownloadUrl, filesComponent, null, false, onDropFiles, onRemoveFile, onChange, {
        mimeTypes: filesMimeTypes,
        extensions: filesExtensions
    });

    return (
        <Fragment>
            <Form
                name="klachten"
                onLeftButtonClick={onSave}
                leftButtonLabel={"Verzend"}
                leftButtonDisabled={sendButtonDisabled}
                isNotRequired
                headerVisible={false}>
                <div style={{ padding: "25px" }}>
                    <p style={{ margin: "10px" }}>Alle velden zijn verplicht tenzij anders aangegeven.</p>
                    <Row>
                        <TextInput
                            name="voornaam"
                            label="Voornaam"
                            value={klachtenModel.voornaam}
                            onChange={onChange}
                            size={6}
                            validationMessage={errors ? errors['voornaam'] : ""}
                        />
                        <TextInput
                            name="achternaam"
                            label="Achternaam"
                            value={klachtenModel.achternaam}
                            onChange={onChange}
                            size={6}
                            validationMessage={errors ? errors['achternaam'] : ""}
                        />
                    </Row>
                    <br />
					<Row>
						<AdresWizard onSave={onAdresSave} model={klachtenModel.adres} errors={errors} />
					</Row>
					<br />
                    <Row>
                        <TextInput
                            name="organisatie"
                            label="Organisatie (optioneel)"
                            value={klachtenModel.organisatie}
                            onChange={onChange}
                            validationMessage={errors ? errors['organisatie'] : ""}
                        />
                    </Row>
                    <Row>
                        <TextInput
                            name="telefoon"
                            label="Telefoon (optioneel)"
                            value={klachtenModel.telefoon}
                            onChange={onChange}
                            size={6}
                            validationMessage={errors ? errors['telefoon'] : ""}
                        />
                        <TextInput
                            name="gsm"
                            label="GSM (optioneel)"
                            value={klachtenModel.gsm}
                            onChange={onChange}
                            size={6}
                            validationMessage={errors ? errors['gsm'] : ""}
                        />
                    </Row>
                    <Row>
                        <TextInput
                            name="email"
                            label="E-mail"
                            value={klachtenModel.email}
                            onChange={onChange}
                            size={6}
                            validationMessage={errors ? errors['email'] : ""}
                        />
                        <TextInput
                            name="bevestigEmail"
                            label="Bevestig e-mail"
                            value={klachtenModel.bevestigEmail}
                            onChange={onChange}
                            size={6}
                            validationMessage={errors ? errors['bevestigEmail'] : ""}
                        />
                    </Row>
                    <Row>
                        <DateInput
                            name="datum"
                            label="Datum"
                            value={klachtenModel.datum}
                            onChange={onChange}
                            size={6}
                            validationMessage={errors ? errors['datum'] : ""}
                        />
                    </Row>
                    <br />
                    <TextAreaInput
                        name="omschrijving"
                        label="Omschrijving"
                        value={klachtenModel.omschrijving}
                        onChange={onChange}
                        height={5}
                        validationMessage={errors ? errors['omschrijving'] : ""}
                    />
                    <Files {...filesProps} />
                    <br />
                    <p>
                        Sport Vlaanderen verwerkt je persoonsgegevens in het kader van een wettelijke verplichting, namelijk het  beheer  van  klachten  volgens <a style={{ color: COLOR_BLUE, textDecoration: 'underline' }} target={"_blank"} href={"https://codex.vlaanderen.be/PrintDocument.ashx?id=1030009&datum=&geannoteerd=false&print=false#H1089348"}>hoofdstuk  5  van  het  bestuursdecreet  van  7  december  2018.</a>  We bewaren jouw gegevens voor een periode van 5 jaar na afhandeling van de klacht. Je kan altijd mailen om te vragen welke persoonsgegevens we verwerken. We vragen dan een bewijs van je identiteit zodat we je gegevens niet meedelen aan iemand die er geen recht op heeft.De gegevens worden verwerkt in een klachtensysteem.
                </p>
                    <br />
                    <p>
                        Als je vragen hebt over de manier waarop we jouw persoonsgegevens verwerken, kun je contact opnemen met het DPO-team van Sport Vlaanderen door te mailen naar <a style={{ color: COLOR_BLUE, textDecoration: 'underline' }} target={"_blank"} href={"mailto:privacy@sport.vlaanderen"}>privacy@sport.vlaanderen</a> Ben je het niet eens met de manier waarop we jouw gegevens verwerken, dan kan je je wenden tot de bevoegde  toezichthoudende  autoriteit.  Ons  beleid  op  het  vlak  van  gegevensverwerking  vind  je  op <a style={{ color: COLOR_BLUE, textDecoration: 'underline' }} target={"_blank"} href={"https://www.sport.vlaanderen/privacybeleid/"}>https://www.sport.vlaanderen/privacybeleid/</a>.
                </p>
					<br/>
					<p>
						<FriendlyCaptcha onVerified={onCaptchaVerified}/>
					</p>
                </div>
            </Form>
        </Fragment>
    );
};

ExterneKlachtenForm.propTypes = {
    klachtenModel: PropTypes.object,
	onAdresSave: PropTypes.func,
    onChange: PropTypes.func,
    onSave: PropTypes.func,
    onDropFiles: PropTypes.func,
	onCaptchaVerified: PropTypes.func,
    onRemoveFile: PropTypes.func,
    fileDownloadUrl: PropTypes.string,
    filesComponent: PropTypes.array,
	sendButtonDisabled: PropTypes.bool,
    errors: PropTypes.array
};

export default ExterneKlachtenForm;
